import React from "react";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Programs from "@/components/Programs";
import WhyChoose from "@/components/WhyChoose";
import JoinCta from "@/components/JoinCta";
import Testimonials from "@/components/Testimonials";

export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Programs />
      <WhyChoose />
      <JoinCta />
      <Testimonials />
    </>
  );
}
